import { useEffect } from 'react';
import { getPreviewUrl } from '../../../../../services/attachmentService';
import { inferFileType } from '../../../utils/fileOverrides';
import {
  makeImageThumbnailFromUrl,
  makeVideoThumbnailFromUrl,
  thumbNeedsRefresh,
} from '../../../utils/imageThumbnail';

export const useStaleThumbRefresh = ({
  canUpload,
  files,
  filesRef,
  missionId,
  reportFiles,
}) => {
  const staleThumbKey = files
    .filter((file) => {
      const kind = inferFileType(file.mimeType, file.filename, file.fileType);
      return (kind === 'image' || kind === 'video') && thumbNeedsRefresh(file.thumbDataUrl);
    })
    .map((file) => file.attachmentId)
    .join(',');

  useEffect(() => {
    if (!canUpload || !staleThumbKey) return undefined;
    let cancelled = false;

    (async () => {
      for (const attachmentId of staleThumbKey.split(',')) {
        if (cancelled) return;
        const file = filesRef.current.find((row) => row.attachmentId === attachmentId);
        if (!file) continue;
        try {
          const { previewUrl } = await getPreviewUrl(missionId, file.attachmentId);
          const kind = inferFileType(file.mimeType, file.filename, file.fileType);
          const thumbDataUrl =
            kind === 'video'
              ? await makeVideoThumbnailFromUrl(previewUrl)
              : await makeImageThumbnailFromUrl(previewUrl);
          if (!thumbDataUrl || cancelled) continue;
          const next = filesRef.current.map((row) =>
            row.attachmentId === file.attachmentId
              ? { ...row, thumbDataUrl }
              : row
          );
          filesRef.current = next;
          reportFiles(next);
        } catch {
          /* keep the existing muddy thumb */
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [canUpload, filesRef, missionId, reportFiles, staleThumbKey]);
};
